import { Fragment, useEffect, useMemo, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { listarMovimientosInventario, limpiarMovimientosInventario } from '../../../actions/inventario';

const Movimientos = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { movimientosListado } = useSelector(state => state.inventario || { movimientosListado: [] });

    const [textoFiltro, setTextoFiltro] = useState('');

    useEffect(() => {
        dispatch(editarBreadcrumb([
            { activo: true, nombre: 'Movimientos', path: '/pdv/inventario/movimientos' }
        ]));
    }, [dispatch]);

    useEffect(() => {
        dispatch(listarMovimientosInventario());

        return () => {
            dispatch(limpiarMovimientosInventario());
        };
    }, [dispatch]);

    const formatNum = (n) => {
        const num = Number(n || 0);
        return new Intl.NumberFormat('es-MX', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };

    const buildUbicacion = (area, organizador, ubicacion) => {
        const a = area?.nombre ? String(area.nombre).trim() : '';
        const o = organizador?.nombre ? String(organizador.nombre).trim() : '';
        const u = ubicacion?.nombre ? String(ubicacion.nombre).trim() : '';

        const parts = [];
        if (a) parts.push(a);
        if (o) parts.push(o);
        if (u) parts.push(u);

        return parts.length ? parts.join(' / ') : 'Sin definir';
    };

    const dataFiltrada = useMemo(() => {
        const q = (textoFiltro || '').trim().toLowerCase();
        const data = Array.isArray(movimientosListado) ? movimientosListado : [];

        const mapped = data.map(m => {
            const producto = m?.producto?.nombre || 'Sin definir';
            const cant = Number(m?.cantidad || 0);
            const conv = Number(m?.conversion || 1);
            const unidad = m?.unidad?.nombre || 'Sin definir';

            const cantidadTexto = `${formatNum(cant * conv)} ${unidad}`;

            const origenTexto = buildUbicacion(m?.area_origen, m?.organizador_origen, m?.ubicacion_origen);
            const destinoTexto = buildUbicacion(m?.area_destino, m?.organizador_destino, m?.ubicacion_destino);

            return {
                ...m,
                _ui_producto: producto,
                _ui_cantidad: cantidadTexto,
                _ui_origen: origenTexto,
                _ui_destino: destinoTexto
            };
        });

        if (!q) return mapped;

        return mapped.filter(m => {
            const p = (m?._ui_producto || '').toLowerCase();
            const o = (m?._ui_origen || '').toLowerCase();
            const d = (m?._ui_destino || '').toLowerCase();
            return p.includes(q) || o.includes(q) || d.includes(q);
        });
    }, [movimientosListado, textoFiltro]);

    const columns = useMemo(() => ([
        {
            name: 'Producto',
            selector: row => row?._ui_producto || 'Sin definir',
            sortable: true,
            wrap: true,
            grow: 2
        },
        {
            name: 'Cantidad (con unidad)',
            selector: row => row?._ui_cantidad || '0.00',
            sortable: true,
            wrap: true,
            grow: 1
        },
        {
            name: 'Origen',
            selector: row => row?._ui_origen || 'Sin definir',
            sortable: true,
            wrap: true,
            grow: 2
        },
        {
            name: 'Destino',
            selector: row => row?._ui_destino || 'Sin definir',
            sortable: true,
            wrap: true,
            grow: 2
        }
    ]), []);

    const paginationOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos'
    };

    const onChangeFiltroTabla = (e) => {
        setTextoFiltro(e.target.value);
    };

    return (
        <Fragment>
            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="my-5">Movimientos de inventario</h3>

                    <div className="d-flex justify-content-end mb-3">
                        <div className="d-flex align-items-center gap-2 w-100 justify-content-end">
                            <div style={{ minWidth: 280 }}>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Buscar en la tabla..."
                                    value={textoFiltro}
                                    onChange={onChangeFiltroTabla}
                                />
                            </div>

                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={() => navigate('/inventario/movimientos/nuevo')}
                            >
                                <i className="feather icon-plus" /> Agregar movimiento
                            </button>
                        </div>
                    </div>

                    <div className="mt-2">
                        <DataTable
                            columns={columns}
                            data={dataFiltrada || []}
                            pagination
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover
                            striped
                            responsive
                            persistTableHead
                            noDataComponent="No hay datos disponibles"
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default Movimientos;